import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import FlagStore from '../FlagStore';

export default class SecurityOptionsStore {
    static PropType = PropTypes.shape({
        maliciousThreatsStore: FlagStore.PropType.isRequired,
        tsaScanStore: FlagStore.PropType.isRequired,

        hasChanged: PropTypes.bool.isRequired,

        setFromObject: PropTypes.func.isRequired,
        toObject: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class SecurityOptionsStore */{
            maliciousThreatsStore: new FlagStore(false),
            tsaScanStore: new FlagStore(true),
            data: null,

            get hasChanged() {
                return !!this.data && (this.maliciousThreatsStore.value !== this.data.checkUnsafe
                    || this.tsaScanStore.value !== this.data.tsaScan);
            },
        }, data);
    }

    setFromObject = action((data) => {
        this.data = data;
        this.maliciousThreatsStore.setValue(data.checkUnsafe);
        this.tsaScanStore.setValue(data.tsaScan);
    });

    toObject = () => ({
        checkUnsafe: this.maliciousThreatsStore.value,
        tsaScan: this.tsaScanStore.value,
    });
}
